import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import styled from "@emotion/styled";
import { FaCheck } from "react-icons/fa6";

const Checkbox = forwardRef((props, ref) => {
  const [isChecked, setIsChecked] = useState(false);
  const [startValue, setStartValue] = useState(false);
  const { input, check, config, style: styleProp } = props;

  const styles = style(props);

  useImperativeHandle(ref, () => ({
    reset() {
      setIsChecked(false);

      if (props.onChange) {
        props.onChange();
      } else {
        input.inputRef.current.value = 0;
      }
    },
  }));

  const updateValue = (e) => {
    setIsChecked(!isChecked);

    if (input.onChange) input.onChange(!isChecked);

    if (props.onChange) {
      props.onChange(e, !isChecked);
    } else {
      if (input?.inputRef?.current) {
        input.inputRef.current.value = input.inputRef.current.checked ? 1 : 0;
      }
    }
  };

  useEffect(() => {
    setIsChecked(check);
  }, [check]);

  useEffect(() => {
    if (!startValue && input.startValue !== undefined) {
      setStartValue(true);

      setIsChecked(input.startValue);
      input.inputRef.current.value = input.startValue ? 1 : 0;

      if (input.onChange) input.onChange(input.startValue);
    }
  }, [input.startValue]);

  const id = props.id || "checkbox" + Math.floor(Math.random() * 10000);

  return (
    <div style={styles.container}>
      <StyledCheckbox {...props} config={config}>
        <input
          type={"checkbox"}
          id={id}
          ref={input?.inputRef}
          checked={isChecked}
          onChange={updateValue}
        />
        <span className={"check-box"} style={styleProp}>
          {isChecked && <FaCheck size={16} color="#ffffff" />}
        </span>
        <span
          className={"check-text"}
          dangerouslySetInnerHTML={{ __html: input?.label }}
        />
      </StyledCheckbox>
      <span style={styles.errorMessage}>{input?.error}</span>
    </div>
  );
});

export default Checkbox;

const style = (props) => {
  return {
    container: {
      position: "relative",
      marginBottom: "20px",
    },
    errorMessage: {
      position: "absolute",
      margin: "2px",
      color: "red",
      left: "0",
      fontSize: "12px",
      fontFamily: "Roboto"
    },
  };
};

const StyledCheckbox = styled.label`
  cursor: pointer;
  font-size: ${(props) => (props.size ? props.size : "14px")};
  user-select: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;

  input {
    display: none;
    margin: 0;
    margin-bottom: 0;
    margin-right: 5px;
    width: 20px;
    height: 20px;
    vertical-align: bottom;

    & + span {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #e6e6e6;
      border: 1px solid rgba(255, 255, 255, 0.1);
      margin-right: 1em;
      font-size: 1em;
    }

    &:checked + span {
      background-color: #006e3d;
      border: 1px solid #006e3d;
    }
  }

  span.check-text {
    flex: 1;
    font-family: "Roboto";
    font-size: 1em;
    color: rgba(0, 59, 33, 1);
  }
`;
